
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -2 16 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-trash)"}},[_c('path',{attrs:{"d":"M14.856 2.786h-4v-.572c0-.946-.768-1.714-1.714-1.714H6.856c-.947 0-1.714.768-1.714 1.714v.572h-4a.571.571 0 100 1.143h.62L2.857 15.98c.027.295.275.52.571.519h9.143a.572.572 0 00.572-.52L14.235 3.93h.621a.571.571 0 100-1.143zm-8.571-.572c0-.315.255-.571.571-.571h2.286c.315 0 .571.256.571.571v.572H6.285v-.572zm5.764 13.143h-8.1L2.913 3.93h10.175l-1.04 11.428z"}}),_c('path',{attrs:{"d":"M6.286 13.604v-.002l-.571-8a.573.573 0 00-1.143.081l.571 8c.022.3.271.532.572.531h.04a.571.571 0 00.531-.61zM8.001 5.071a.571.571 0 00-.571.572v8a.571.571 0 101.143 0v-8A.571.571 0 008 5.07zM10.896 5.071a.573.573 0 00-.612.531l-.572 8a.571.571 0 00.529.612h.042c.301 0 .551-.231.572-.53l.572-8a.573.573 0 00-.531-.613z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-trash"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    